import {ofType} from 'redux-observable';
import {of} from 'rxjs';
import {mergeMap, filter} from 'rxjs/operators';
import {AnyAction} from 'redux';
import * as WizardActions from '../../../actions/WizardActions';
import {COUNTRIES} from '../../../constants/AppConstants';
import {calculateRFC} from '../../../../common/utils/RFCUtils';
import * as ValidateConstant from '../../../constants/ValidateConstant';

export const calculateRfcMX = (action$, state$) =>
    action$.pipe(
        ofType(WizardActions.CHANGE_FIRST_NAME_ACTION.name,
        WizardActions.CHANGE_SECOND_NAME_ACTION.name,
        WizardActions.CHANGE_LAST_NAME_ACTION.name,
        WizardActions.CHANGE_SECOND_LAST_NAME_ACTION.name,
        WizardActions.CHANGE_BIRTH_DATE_ACTION.name),
        filter((action: AnyAction) => COUNTRIES.MX.id === action.country),
        mergeMap((action: AnyAction) => {
            const applicantPersonal = state$.value.creditoReal.loanApplication.applicantPersonal;
            const firstName = action.firstName ? action.firstName : applicantPersonal.firstName;
            const secondName = action.secondName ? action.secondName : applicantPersonal.secondName;
            const lastName = action.lastName ? action.lastName : applicantPersonal.lastName;
            const secondLastName = action.secondLastName ? action.secondLastName : applicantPersonal.secondLastName;
            const birthDate = action.birthDate ? action.birthDate : applicantPersonal.birthDate;
            const docNumber = calculateRFC(lastName, secondLastName, firstName, secondName, birthDate);
            const error = docNumber === ''
                ? ValidateConstant.ERROR_REQUIRED
                : docNumber.length != 13
                ? ValidateConstant.ERROR_MIN_LENGTH(13)
                : null;
            return of(WizardActions.CHANGE_DOC_NUMBER_ACTION.action(docNumber, error));
        }
        ));
